import { Group, Modal, Stack, Text, Title } from '@mantine/core';

import { useTranslation } from 'react-i18next';

import { Button } from '../../../../../../../../shared/components/UI/Button/Button';

import type { ResponseProjectBlock } from '../../../../../../../../shared/entities/ResponseProjectBlock';
import { useDeleteResponseProjectBlockMutation } from '../../../../hooks/useDeleteResponseProjectBlock.hooks';

interface ResponseProjectDeleteBlockProps {
  isOpen: boolean;
  onClose: () => void;
  block: ResponseProjectBlock;
}

export function ResponseProjectDeleteBlock(
  props: ResponseProjectDeleteBlockProps,
) {
  if (props.block && props.isOpen) {
    return <SafeResponseProjectDeleteBlock {...props} />;
  }
  return null;
}

function SafeResponseProjectDeleteBlock({
  isOpen,
  onClose,
  block,
}: ResponseProjectDeleteBlockProps) {
  const { t } = useTranslation('bidResponse');
  const { mutateAsync: deleteBlock } = useDeleteResponseProjectBlockMutation(
    block.projectId,
  );

  const onSubmit = async () => {
    await deleteBlock({ blockId: block.id });
    onClose();
  };

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      withCloseButton={false}
      radius="md"
      centered={true}
      styles={{
        body: {
          padding: 0,
        },
      }}
    >
      <Stack p="05" spacing="00">
        <Title order={5} pb="05">
          {t('projectDetail.deleteBlock.title')}
        </Title>
        <Text size="sm">{t('projectDetail.deleteBlock.description')}</Text>
        <Group position="right" mt="04">
          <Button variant="subtle" onClick={onClose} color="gray">
            {t('projectDetail.deleteBlock.cancelButton')}
          </Button>
          <Button size="md" onClick={onSubmit} color="red">
            {t('projectDetail.deleteBlock.submitButton')}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
